import React, { useState } from 'react';
import Navbar from '../../../Components/Navbar';
import { toast } from 'react-toastify';
import { Create_Api } from '../../../API/Api_Url';
import { useNavigate, useParams } from 'react-router-dom';

function UserSignUp() {
    const navigate = useNavigate()
    const [IsUploading, setIsUploading] = useState(false);
    const [Name, setName] = useState('');
    const [Email, setEmail] = useState('');
    const [password, setpassword] = useState('');
    const [Number, setNumber] = useState('');
    const [AcceptedTerms, setAcceptedTerms] = useState(false);


    const [errors, setErrors] = useState({});
    const validateForm = () => {
        const newErrors = {};

        if (!Name) newErrors.Name = 'Name is required.';

        if (!Email) newErrors.Email = 'Email is required.';
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(Email))
            newErrors.Email = 'Please enter a valid email address.';

        if (!password) newErrors.password = 'Password is required.';
        else if (password.length < 6)
            newErrors.password = 'Password must be at least 6 characters long.';

        if (!Number) newErrors.Number = 'Contact Number is required.';
        else if (!/^\d{10}$/.test(Number))
            newErrors.Number = 'Mobile number must be exactly 10 digits.';

        if (!AcceptedTerms) newErrors.AcceptedTerms = 'Please accept the Terms and Conditions.';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSignup = async () => {
        try {
            if (validateForm()) {

                const data = {
                    name: Name,
                    email: Email,
                    phone: Number,
                    password
                };

                setIsUploading(true);
                const response = await Create_Api(`api/user/register`, data);
                console.log('Signup Successful:', response?.data);
                localStorage.removeItem("UserType");
                localStorage.removeItem("user");
                localStorage.removeItem("userToken");
                localStorage.setItem('UserType', 'User');
                localStorage.setItem('user', JSON.stringify(response?.data?.user));
                localStorage.setItem('userToken', response?.data?.tokens?.accessToken);
                toast.success(response?.message);
                setName('');
                setEmail('');
                setNumber('');
                setpassword('');
                navigate('/');
                setTimeout(() => window.location.reload(), 3000);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
            console.error(error);
        } finally {
            setIsUploading(false);
        }
    };

    const countryCodes = [
        { code: "+91", label: "India" },
        { code: "+1", label: "USA" },
        { code: "+44", label: "UK" },
        { code: "+61", label: "Australia" },
        { code: "+81", label: "Japan" },
    ];



    return (
        <>
            <Navbar />
            <div className="signup-container">
                <div className="signup-form">
                    <h3 className="signup-title">Sign Up</h3>
                    <p className="signup-subtitle">
                        Get free quotes from contractors .
                    </p>
                    <label className="signup-label">Name</label>
                    <input
                        type="text"
                        name="name"
                        value={Name}
                        onChange={(e) => { setName(e.target.value) }}
                        className="signup-input"
                    />
                    {errors?.Name && <span className="error-text">{errors?.Name}</span>}

                    <label className="signup-label">Email</label>
                    <input
                        type="email"
                        name="email"
                        value={Email}
                        onChange={(e) => { setEmail(e.target.value) }}
                        className="signup-input"
                    />
                    {errors?.Email && <span className="error-text">{errors?.Email}</span>}
                    <>
                        <label className="signup-label">Contact Number</label>
                        <div className="phone-input-wrapper">
                            <select
                                className="country-code-dropdown"
                            >
                                {countryCodes.map((country) => (
                                    <option key={country.code} value={country.code}>
                                        {country.label} ({country.code})
                                    </option>
                                ))}
                            </select>
                            <input
                                type="number"
                                name="Number"
                                value={Number}
                                onChange={(e) => { setNumber(e.target.value) }}
                                className="signup-input no-spinner phone-input"
                                placeholder="Enter 10-digit number"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") e.preventDefault();
                                }}
                            />
                        </div>
                    </>
                    {errors?.Number && <span className="error-text">{errors?.Number}</span>}
                    <label className="signup-label">Password</label>
                    <input
                        type="password"
                        name="password"
                        value={password}
                        onChange={(e) => { setpassword(e.target.value) }}
                        className="signup-input"
                    />
                    {errors?.password && <span className="error-text">{errors?.password}</span>}
                    <div className="signup-terms">
                        <input
                            type="checkbox"
                            id="terms"
                            checked={AcceptedTerms}
                            onChange={(e) => setAcceptedTerms(e.target.checked)}
                        />
                        <label htmlFor="terms" className="signup-label" style={{ marginLeft: '8px' }}>
                            I accept the <a href="/terms" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
                        </label>
                    </div>
                    {errors?.AcceptedTerms && <span className="error-text">{errors?.AcceptedTerms}</span>}

                    <button
                        onClick={() => { handleSignup() }}
                        className="signup-button"
                        disabled={IsUploading}
                    >
                        {IsUploading ? (
                            <span className="loader"></span>
                        ) : (
                            'Create Account'
                        )}
                    </button>
                    <div className="account-exists">
                        <p>
                            Already have an account?{" "}
                            <button
                                className="account-exists-btn"
                                onClick={() => navigate("/ph-UserLogin")}
                            >
                                Sign In
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserSignUp;
